import {
    ApDropdown,
    ApDropdownItem,
} from '@uipath/portal-shell-react';
import React, {
    useEffect,
    useState,
} from 'react';
import type { ControllerRenderProps } from 'react-hook-form';
import { useIntl } from 'react-intl';

import type { ByoLlmConfiguration } from '../../../../services/llm-gateway/LlmGateway.types';
import { ModelFamily } from '../../../../services/llm-gateway/LlmGateway.types';
import type { AddEditConfigurationFormData } from '../AddEditConfigurationViewModel';

interface AiGatewayDialectProps {
    value?: string;
    disabled?: boolean;
    availableDialects?: ModelFamily[];
    llmConfigurationsField: ControllerRenderProps<AddEditConfigurationFormData, 'llmConfigurations'>;
    notifyFieldChanges: () => void;
    desiredModel: string;
    llmConfiguration: Partial<ByoLlmConfiguration>;
}

export const AiGatewayDialectDropdown: React.FC<AiGatewayDialectProps> = ({
    value,
    disabled,
    availableDialects,
    llmConfigurationsField,
    notifyFieldChanges,
    desiredModel,
    llmConfiguration,
}) => {
    const { formatMessage: translate } = useIntl();
    const [ selectedValue, setSelectedValue ] = useState<string | undefined>(value);

    const dialects = availableDialects ?? Object.values(ModelFamily);

    useEffect(() => {
        setSelectedValue(value);
    }, [ value ]);

    return (
        <ApDropdown
            style={{ width: '350px' }}
            label={translate({ id: 'CLIENT_AI_GATEWAY_DIALECT' })}
            selectedValue={selectedValue}
            onSelectedValueChanged={(event: CustomEvent) => {
                const newValue = event.detail as ModelFamily;
                setSelectedValue(newValue);

                const updatedConfiguration: Partial<ByoLlmConfiguration> = ({
                    ...(llmConfiguration),
                    gatewayParameters: {
                        apiUrl: llmConfiguration.gatewayParameters?.apiUrl ?? '',
                        authConnectionId: llmConfiguration.gatewayParameters?.authConnectionId ?? '',
                        authConnectorType: llmConfiguration.gatewayParameters?.authConnectorType ?? '',
                        vendorApiType: newValue,
                    },
                });

                llmConfigurationsField.onChange({
                    ...llmConfigurationsField.value,
                    [desiredModel]: updatedConfiguration,
                });
                notifyFieldChanges();
            }}
            disabled={disabled}
            data-cy='ai-gateway-dialect-dropdown'>
            {dialects.map((dialect) => (
                <ApDropdownItem
                    key={dialect}
                    value={dialect}
                    label={dialect}
                />
            ))}
        </ApDropdown>
    );
};
